import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';
import '../styles.scss';

export default function AnaliticoMixClienteVolume(dados) {
  return (
    <div>
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!dados?.isLoading && dados?.faturamentoClientesVolumes?.length > 0 ? (
          ([...dados?.faturamentoClientesVolumes] || [])?.map((vendedor, index) => (
            <div className="vendedor" key={index}>
              <p className="mb-3 fw-600" style={{ fontSize: '1.3em' }}>
                {vendedor.vendedorNome}
              </p>

              <Table striped bordered hover width="100%" className="table-relatorio">
                <thead>
                  <tr>
                    {/* <th>#</th> */}
                    <th>Cliente</th>
                    <th>Produto</th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 2)?.label}
                    </th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 1)?.label}
                    </th>
                    <th>{lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado)?.label}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                {vendedor?.clientes?.length > 0 ? (
                  ([...vendedor?.clientes] || [])?.map((cliente, indexCliente) => (
                    <tbody className="table-sem-totalizadores" key={indexCliente}>
                      <tr className="fw-600">
                        {/* <td></td> */}
                        <td>{cliente.clienteNome}</td>
                        <td>CNPJ: {cliente.clienteCnpj}</td>
                        <td>{lib.formatToNumeric(cliente.volumeMesAntepenultimo, 3, true)} Kg</td>
                        <td>{lib.formatToNumeric(cliente.volumeMesAnterior, 3, true)} Kg</td>
                        <td>{lib.formatToNumeric(cliente.volumeMesAtual, 3, true)} Kg</td>
                        <td>{lib.formatToNumeric(cliente.volumeTotalTrimestre, 3, true)} Kg</td>
                      </tr>

                      {cliente?.produtos?.map((produto, produtoIndex) => (
                        <tr key={produtoIndex}>
                          {/* <td>{produtoIndex + 1}</td> */}
                          <td></td>
                          <td>{produto.produtoNome}</td>
                          <td>{lib.formatToNumeric(produto.volumeMesAntepenultimo, 3, true)} Kg</td>
                          <td>{lib.formatToNumeric(produto.volumeMesAnterior, 3, true)} Kg</td>
                          <td>{lib.formatToNumeric(produto.volumeMesAtual, 3, true)} Kg</td>
                          <td>{lib.formatToNumeric(produto.volumeTotalTrimestre, 3, true)} Kg</td>
                        </tr>
                      ))}
                    </tbody>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </Table>

              {index + 1 < dados?.faturamentoClientesVolumes?.length ? (
                <hr className="my-5" />
              ) : null}
            </div>
          ))
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
    // </Layout>
  );
}
